import Swiper from 'swiper/bundle';

const CaseStudies = () => {
    const sliders = document.querySelectorAll('.case-studies__swiper');
    if (!sliders.length) return;

    sliders.forEach((slider) => {
        // helper: keep only visible slides tabbable
        function updateSlideTabbing(sw) {
            sw.slides.forEach((slide) => {
                const isVisible =
                    slide.classList.contains('swiper-slide-visible') ||
                    slide.classList.contains('swiper-slide-active');

                // focusables you care about (overlay link + any other controls)
                const focusables = slide.querySelectorAll(
                    'a[href], button, input, select, textarea, [tabindex]'
                );

                focusables.forEach((el) => {
                    if (isVisible) {
                        // allow tabbing (remove -1 if previously set)
                        if (el.getAttribute('tabindex') === '-1') {
                            el.removeAttribute('tabindex');
                        }
                    } else {
                        // keep offscreen slides out of tab order
                        el.setAttribute('tabindex', '-1');
                    }
                });
            });
        }

        const swiper = new Swiper(slider, {
            slidesPerView: 1.05,
            spaceBetween: 20,
            loop: false,
            centeredSlides: false,

            // make Swiper mark visible slides for us
            watchSlidesProgress: true,

            // optional but nice for keyboard users
            a11y: { enabled: true },
            keyboard: { enabled: true, onlyInViewport: true },

            breakpoints: {
                1024: {
                    slidesPerView: 'auto',
                    centeredSlides: true,
                    loop: true,
                    spaceBetween: 20,
                    pagination: {
                        el: slider.querySelector('.case-studies__pagination'),
                        clickable: true,
                    },
                },
            },

            on: {
                imagesReady() {
                    this.update();
                    updateSlideTabbing(this);
                },
                init() {
                    setTimeout(() => {
                        this.update();
                        // if loop is active at this breakpoint, align to first looped slide
                        this.slideToLoop(0, 0);
                        updateSlideTabbing(this);
                    }, 50);
                },
                slideChange() {
                    updateSlideTabbing(this);
                },
                resize() {
                    updateSlideTabbing(this);
                },
                slidesLengthChange() {
                    updateSlideTabbing(this);
                },
                // when visibility classes update during movement
                progress() {
                    updateSlideTabbing(this);
                },
            },
        });
    });
};

export default CaseStudies;
